<template>
  <base-content>
    <template v-slot:top>
      <project-heading actions>Loan Application</project-heading>
    </template>
    <template v-if="loaded">
      <component :is="getDashboard()"/>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import ProjectAdminDashboard from '@/components/ProjectAdminDashboard.vue'
import ProjectBorrowerDashboard from '@/components/ProjectBorrowerDashboard.vue'
import ProjectHeading from '@/components/ProjectHeading.vue'

export default {
  async created () {
    await this.$store.dispatch('core/projects/get', this.$route.params.id)

    this.loaded = true
  },

  data: () => ({
    loaded: false
  }),

  components: {
    ProjectAdminDashboard,
    ProjectBorrowerDashboard,
    ProjectHeading
  },

  methods: {
    getDashboard () {
      return this.$auth.borrower() ? 'ProjectBorrowerDashboard' : 'ProjectAdminDashboard'
    }
  }
}
</script>
